import { IconProps } from "./IconProps";

export const CopyIcon18 = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1658_5670)">
        <path
          d="M6.752 17H14.072C15.6891 17 17 15.689 17 14.072V6.75195M14.176 11.248C14.176 12.8651 12.8651 14.176 11.248 14.176H3.928C2.31091 14.176 1 12.8651 1 11.248V3.928C1 2.31091 2.31091 1 3.928 1H11.248C12.8651 1 14.176 2.31091 14.176 3.928V11.248Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1658_5670">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
